import React from 'react';
import {
  BsFillCloudArrowDownFill,
  BsSearch,
  BsFillPenFill,
  BsFillTrashFill,
  BsBookHalf,
  BsFillXCircleFill,
  BsSave2Fill,
  BsPrinterFill,
  BsFillCheckCircleFill,
  BsLockFill,
  BsArrowLeftCircleFill,
  BsFillPlusCircleFill,
  BsArrowClockwise,
  BsShieldFillCheck,
  BsPersonCheckFill,
  BsKanban,
  BsJournalBookmarkFill,
  BsLayoutSidebarInsetReverse,
  BsTruck,
  BsEye,
} from 'react-icons/bs';
import {
  RiLogoutBoxRFill,
  RiLoginBoxFill,
  RiExchangeLine,
  RiTicket2Fill,
  RiFileTransferFill,
  RiCheckFill,
} from 'react-icons/ri';
import { IoSettingsOutline, IoBookmarks, IoAlertCircleSharp, IoCheckbox } from 'react-icons/io5';
import { HiDotsCircleHorizontal } from 'react-icons/hi';
import {
  FaAngleDoubleLeft,
  FaBook,
  FaBoxOpen,
  FaChevronCircleDown,
  FaExternalLinkAlt,
  FaFileAlt,
  FaFileImport,
  FaHourglass,
  FaLine,
  FaPaperPlane,
  FaQrcode,
  FaRegistered,
  FaTimes,
  FaUsers,
} from 'react-icons/fa';
import { MdWavingHand } from 'react-icons/md';
import { FiChevronRight } from 'react-icons/fi';
import { EditFilled } from '@ant-design/icons';
import { MdCancel } from 'react-icons/md';

/**
 * React Icons --> https://react-icons.github.io/react-icons/
 */
export const Icon = {
  Download: (props) => <BsFillCloudArrowDownFill {...props} />,
  Search: (props) => <BsSearch {...props} />,
  Edit: (props) => <BsFillPenFill {...props} />,
  Remove: (props) => <BsFillTrashFill {...props} />,
  View: (props) => <BsBookHalf {...props} />,
  Clear: (props) => <BsFillXCircleFill {...props} />,
  Cancel: (props) => <BsFillXCircleFill {...props} />,
  Logout: (props) => <RiLogoutBoxRFill {...props} />,
  Login: (props) => <RiLoginBoxFill {...props} />,
  Save: (props) => <BsSave2Fill {...props} />,
  Evernote: (props) => <FaBook {...props} />,
  Print: (props) => <BsPrinterFill {...props} />,
  Detail: (props) => <BsEye {...props} />,
  Box: (props) => <FaBoxOpen {...props} />,
  Hourglass: (props) => <FaHourglass {...props} />,
  Truck: (props) => <BsTruck {...props} />,
  Confirm: (props) => <BsFillCheckCircleFill {...props} />,
  Times: (props) => <FaTimes {...props} />,
  PaperPlane: (props) => <FaPaperPlane {...props} />,
  ForgetPassword: (props) => <BsLockFill {...props} />,
  Back: (props) => <BsArrowLeftCircleFill {...props} />,
  DoubleLeft: (props) => <FaAngleDoubleLeft {...props} />,
  Create: (props) => <BsFillPlusCircleFill {...props} />,
  ReAct: (props) => <BsArrowClockwise {...props} />,
  Recheck: (props) => <BsShieldFillCheck {...props} />,
  Change: (props) => <RiExchangeLine {...props} />,
  Line: (props) => <FaLine {...props} />,
  Edit2: (props) => <EditFilled {...props} />,
  Register: (props) => <BsPersonCheckFill {...props} />,
  Settings: (props) => <IoSettingsOutline {...props} />,
  ThreeDots: (props) => <HiDotsCircleHorizontal {...props} />,
  DownCircle: (props) => <FaChevronCircleDown {...props} />,
  Bookmark: (props) => <IoBookmarks {...props} />,
  Alert: (props) => <IoAlertCircleSharp {...props} />,
  CheckboxSquare: (props) => <IoCheckbox {...props} />,
  WavingHand: (props) => <MdWavingHand {...props} />,
  External: (props) => <FaExternalLinkAlt {...props} />,
  Cancel2: (props) => <MdCancel {...props} />,
  Import: (props) => <FaFileImport {...props} />,
  Ticket: (props) => <RiTicket2Fill {...props} />,
  Transfer: (props) => <RiFileTransferFill {...props} />,
  Check: (props) => <RiCheckFill {...props} />,
  /** MENU ICON */
  Dashboard: (props) => <BsKanban {...props} />,
  Todo: (props) => <BsJournalBookmarkFill {...props} />,
  FormExample: (props) => <BsLayoutSidebarInsetReverse {...props} />,
  Registered: (props) => <FaRegistered {...props} />,
  FileSearch: (props) => <FaFileAlt {...props} />,
  Qrcode: (props) => <FaQrcode {...props} />,
  Users: (props) => <FaUsers {...props} />,
};
export const StepIcon = () => {
  return <FiChevronRight size={20} style={{ color: 'grey' }} />;
};
